import { Component, HostListener, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarData } from "src/app/common/components/snackbar/model/snackbar.model";
import { SnackBarService } from "src/app/common/components/snackbar/snackbar.service";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "src/app/common/components/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { DirtyCheck } from "src/app/common/guards/form-deactivate.guard";
import { WeeklyResultByStoreReportService } from "src/app/pages/common/reports/weekly-result-by-store-report/weekly-result-by-store-report.service";
import { ShopinfoService } from "src/app/pages/common/system/shopinfo/shopinfo.service";
import { DepartmentService } from "src/app/pages/common/system/department/department.service";
import { FormsModule } from "@angular/forms";
import moment from "moment";
import { HourlySalesReportService } from "../hourly-sales-report/hourly-sales-report.service";
import { UserInfoModel } from "src/app/common/models/user-info.model";
import { AppConstants } from "src/app/common/app.constants";

import { TerminalService } from "src/app/pages/common/system/terminal/terminal.service";
import { SaleItemService } from "src/app/pages/common/products/sale-item/sale-item.service";
import { ItemCategoryService } from "src/app/pages/common/products/item-category/item-category.service";
import { MasterSalesReportCostService } from "src/app/pages/shop/reports/master-sales-report-cost/master-sales-report-cost.service";
import { AccessLogService } from "src/app/pages/shop/reports/access-log/access-log.service";
import { AreaService } from "../../system/area/area.service";
import { MasterSalesReportService } from "./master-sales-report.service";
import e from "express";
import { PermissionService } from "src/app/auth/permission.service";

@Component({
  selector: "app-master-sales-report",
  standalone: false,
  templateUrl: "./master-sales-report.component.html",
  styleUrl: "./master-sales-report.component.scss",
})
export class MasterSalesReportComponent {
  user: UserInfoModel | undefined;
  title: string = "Master Sales Report";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  departmentListData: any = [];
  // In your component class
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  shopsIsOpen = false;
  orderSourceIsOpen = false;
  areaIsOpen = false;
  shopIsOpen = false;
  deparmentSourceIsOpen = false;
  itemSourceIsOpen = false;
  mainGroupSourceIsOpen = false;
  groupSourceIsOpen = false;

  curFinYear!: string; // Add this to your component properties
  daysOfWeek: string[] = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  hours: string[] = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  fromHour: string = "00";
  toHour: string = "00";
  shop_id: any;
  shop_name: any;
  departmentValidationMessage: any;
  departmentSelectionInvalid: boolean = false;
  isExpandedOrder = false;
  isExpandedArea = false;
  isExpandedShop = false;
  isExpandedDepartment = false;
  isExpandedMainGroup = false;
  isExpandedGroup = false;
  isExpandedItem = false;
  isExpandedSort = false;
  orderSourceListData: any = [];
  areaListData: any = [];
  usersListData: any = [];
  itemListData: any = [];
  groupListData: any = [];
  mainGroupListData: any = [];
  shopListData: any = [];
  // Filter variables for each dropdown
  orderSourceFilter: string = '';
  shopFilter: string = '';
  regionFilter: string = '';
  departmentFilter: string = '';
  mainGroupFilter: string = '';
  groupFilter: string = '';
  itemFilter: string = '';
  permission: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private hourlySalesReportService: HourlySalesReportService,
    private masterSalesReportService: MasterSalesReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    private departmentService: DepartmentService,
    public dialog: MatDialog,
    private areaService: AreaService,
    private accessLogService: AccessLogService,
    private saleItemService: SaleItemService,
    private permissionService: PermissionService,
    private itemCategoryService: ItemCategoryService
  ) {
    const today = new Date();
    this.editForm = this.builder.group({
      // year: this.builder.control( ''),
      period_from: this.builder.control(today, Validators.required),
      period_to: this.builder.control(today, Validators.required),
      days: this.builder.group({}),
      percentage_calculation: this.builder.control(0),
      summary_report: this.builder.control(true),
      sortBy: this.builder.control('total'), // default value
      orderBy: this.builder.control('asc'),
      includeShopDetails: this.builder.control(false),
      showDepGrpMainGrp: this.builder.control(false),
      orderSourceFilter: this.builder.control(''),
      shopFilter: this.builder.control(''),
      regionFilter: this.builder.control(''),
      departmentFilter: this.builder.control(''),
      mainGroupFilter: this.builder.control(''),
      groupFilter: this.builder.control(''),
      itemFilter: this.builder.control(''),
      orderSourceFilterAll: [''],
      orderSourceFilterSelected: [''],
      shopFilterAll: [''],
      shopFilterSelected: [''],
      regionFilterAll: [''],
      regionFilterSelected: [''],
      departmentFilterAll: [''],
      departmentFilterSelected: [''],
      mainGroupFilterAll: [''],
      mainGroupFilterSelected: [''],
      groupFilterAll: [''],
      groupFilterSelected: [''],
      itemFilterAll: [''],
      itemFilterSelected: ['']
    }, { validators: [this.hourRangeValidator(), this.dateRangeWithinOneYearValidator()] }); // <-- add validator here

    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });

    // Load saved data if it exists
    // this.loadFromSessionStorage();
    // Set all days as checked by default
    const daysGroup = this.editForm.get("days") as FormGroup;
    this.daysOfWeek.forEach((day) => {
      daysGroup.addControl(day, new FormControl(true)); // ✅ checked by default
    });
    this.permission = permissionService.getPagePermission("master-sales-report");
    console.log(this.permission);
  }

  ngOnInit(): void {
    // this.loadData();
    this.deparmentList();
    this.OrderSourceList();
    this.areaList();
    this.UsersList();
    this.itemList();
    this.groupList();
    this.mainGroupList();
    this.shopList();
    let sesUser = sessionStorage.getItem(AppConstants.SESSION_VAR_USER);
    this.user = sesUser !== null ? JSON.parse(sesUser) : undefined;
    console.log(this.user);
  }

  selectedDays(): string[] {
    const days = this.editForm.get("days")?.value;
    return Object.keys(days).filter((day) => days[day]);
  }

  // Custom validator function
  hourRangeValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get("fromHour")?.value;
      const to = group.get("toHour")?.value;

      if (from != null && to != null && from > to) {
        return { invalidHourRange: true };
      }
      return null;
    };
  }

  // Validator to ensure date range is <= 365 days
  dateRangeWithinOneYearValidator(): ValidatorFn {
    return (group: AbstractControl): { [key: string]: any } | null => {
      const from = group.get('period_from')?.value;
      const to = group.get('period_to')?.value;
      if (from && to) {
        const fromDate = moment(from);
        const toDate = moment(to);
        if (toDate.diff(fromDate, 'days') >= 365) {
          return { dateRangeTooLong: true };
        }
      }
      return null;
    };
  }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find((week) => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  sortOptions = [
    { value: "shop_name", label: "Shop Name" },
    { value: "this_year_this_week_sales", label: "This Year Sales" },
    { value: "last_year_this_week_sales", label: "Last Year Sales" },
    { value: "this_week_cust_orders", label: "This Year Customer Orders" },
    { value: "last_year_cus_order", label: "Last Year Customer Orders" },
    { value: "this_week_labour_cost", label: "This Year Labour Cost" },
    {
      value: "last_year_this_week_labour_cost",
      label: "Last Year Labour Cost",
    },
  ];

  sortOrderOptions = [
    { value: "asc", label: "Ascending" },
    { value: "desc", label: "Descending" },
  ];

  saveToSessionStorage(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    const selectedShopIds = this.departmentListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

    if (shopIds.length === 0) {
      this.departmentSelectionInvalid = true;
      return;
    } else {
      this.departmentSelectionInvalid = false; // ✅ clear message when valid
    }

    // Create the data object
    const reportData = {
      year: this.editForm.get("year")?.value,
      weekNo: this.editForm.get("week_no")?.value,
      shopId: shopIds,
      sortBy: this.editForm.get("sort_by")?.value,
      sortDir: this.editForm.get("sort_order")?.value,
      isExport: 0,
    };

    // Save to sessionStorage
    sessionStorage.setItem("weeklyStoreReportData", JSON.stringify(reportData));
  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem("weeklyStoreReportData");
    // console.log(savedData)
    if (savedData) {
      const reportData = JSON.parse(savedData);

      // Set form values
      this.editForm.patchValue(
        {
          year: reportData.year,
          week_no: reportData.weekNo,
          sort_by: reportData.sortBy,
          sort_order: reportData.sortDir,
        },
        { emitEvent: false }
      ); // Prevent infinite loop

      // Set shop selections (if shop IDs were saved)
      if (reportData.shopId && reportData.shopId.length > 0) {
        this.departmentListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        // If no shops were selected before, reset all to false (treat as "ALL")
        this.departmentListData.forEach((shop: any) => (shop.selected = false));
      }

      // Manually trigger year change if needed
      if (reportData.year) {
        this.onYearChange();
      }
    }
  }

  onYearChange(): void {
    this.selectedYear = this.editForm.get("year")?.value;
    console.log("Selected Year:", this.selectedYear);

    // Find the selected financial year from financialYears array
    const selectedFinYear = this.financialYears.find(
      (fy) => fy.year === this.selectedYear
    );

    if (selectedFinYear) {
      // Map the weeks to the format needed for the dropdown
      this.weeks = selectedFinYear.weeks.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${week.start_date
          } - ${week.end_date})`,
      }));

      // Set the first week as default if weeks exist
      if (this.weeks.length > 0) {
        this.editForm.get("week_no")?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get("week_no")?.setValue(null);
    }
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, "0");
  }

  deparmentList(): void {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: { offset: 0, limit: 1000000 },
        },
        sort: [{ column: "name", order: "ASC" }],
      },
    };

    this.departmentService.getDepartmentList(requestData).subscribe(
      (response: any) => {
        this.departmentListData = [];
        var index = 0;
        response.data.departments.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.departmentListData.push(data);
          index++;
        });
        console.log("data", this.departmentListData);
      },
      (error: any) => { }
    );
  }

  OrderSourceList(): void {
    let requestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: { offset: 0, limit: 1000000 },
        },
        sort: [{ column: "name", order: "ASC" }],
      },
    };

    this.masterSalesReportService.getOrderSourceList(requestData).subscribe(
      (response: any) => {
        this.orderSourceListData = [];
        var index = 0;
        response.data.order_source.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.orderSourceListData.push(data);
          index++;
        });
        console.log("data", this.orderSourceListData);
      },
      (error: any) => { }
    );
  }

  areaList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "name", order: "ASC" }],
      },
    };

    this.areaService.getAreaList(requestData).subscribe(
      (response: any) => {
        this.areaListData = [];
        var index = 0;
        response.data.areas.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.areaListData.push(data);
          index++;
        });
        console.log(this.areaListData);
      },
      (error: any) => { }
    );
  }

  UsersList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "name", order: "ASC" }],
      },
    };

    this.accessLogService.getUsers().subscribe(
      (response: any) => {
        this.usersListData = [];
        var index = 0;
        response.data.users.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.usersListData.push(data);
          index++;
        });
        console.log(this.usersListData);
      },
      (error: any) => { }
    );
  }

  itemList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "sale_item.name", order: "ASC" }],
      },
    };

    this.saleItemService.getList(requestData).subscribe(
      (response: any) => {
        this.itemListData = [];
        var index = 0;
        response.data.items.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.itemListData.push(data);
          index++;
        });
        console.log(this.itemListData);
      },
      (error: any) => { }
    );
  }

  groupList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "item_classes.name", order: "ASC" }],
      },
    };

    this.itemCategoryService.getList(requestData).subscribe(
      (response: any) => {
        this.groupListData = [];
        var index = 0;
        response.data.categories.forEach((item: any) => {
          if (item.is_super_class_id != null && item.is_super_class_id !== 0) {
            var data = { index: index, item: item, selected: false };
            this.groupListData.push(data);
            index++;
          }
        });
        console.log("data", this.groupListData);
      },
      (error: any) => { }
    );
  }

  mainGroupList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "item_classes.name", order: "ASC" }],
      },
    };

    this.itemCategoryService.getList(requestData).subscribe(
      (response: any) => {
        this.mainGroupListData = [];
        let index = 0;
        response.data.categories.forEach((item: any) => {
          if (item.is_super_class_id === null || item.is_super_class_id === 0) {
            let data = { index: index, item: item, selected: false };
            this.mainGroupListData.push(data);
            index++;
          }
        });
        console.log("data", this.mainGroupListData);
      },
      (error: any) => {
        console.error("Error fetching data:", error);
      }
    );
  }
  // Filtered getters for each dropdown

  showSelectedOrderOnly: boolean = false;
  showSelectedShopOnly: boolean = false;
  showSelectedAreaOnly: boolean = false;
  showSelectedDepartmentOnly: boolean = false;
  showSelectedMainGroupOnly: boolean = false;
  showSelectedGroupOnly: boolean = false;
  showSelectedItemOnly: boolean = false;

  get filteredOrderSourceListData() {
    const filter = this.editForm.get('orderSourceFilter')?.value || '';
    let filteredList = this.orderSourceListData;

    if (this.showSelectedOrderOnly) {
      filteredList = filteredList.filter((item: { selected: any; }) => item.selected);
    }

    if (!filter.trim()) return filteredList;
    const filterValue = filter.trim().toLowerCase();
    return filteredList.filter((item: { item: { name: string; }; }) =>
      item.item.name.toLowerCase().includes(filterValue)
    );
  }

  get filteredShopListData() {
    const filter = this.editForm.get('shopFilter')?.value || '';
    let filteredList = this.shopListData;
    if (this.showSelectedShopOnly) {
      filteredList = filteredList.filter((item: { selected: any; }) => item.selected);
    }
    if (!filter.trim()) return filteredList;
    const filterValue = filter.trim().toLowerCase();
    return filteredList.filter((item: { item: { name: string; }; }) =>
      item.item.name.toLowerCase().includes(filterValue)
    );
  }

  get filteredAreaListData() {
    const filter = this.editForm.get('regionFilter')?.value || '';
    let filteredList = this.areaListData;
    if (this.showSelectedAreaOnly) {
      filteredList = filteredList.filter((item: { selected: any; }) => item.selected);
    }
    if (!filter.trim()) return filteredList;
    const filterValue = filter.trim().toLowerCase();
    return filteredList.filter((item: { item: { name: string; }; }) =>
      item.item.name.toLowerCase().includes(filterValue)
    );
  }

  get filteredDepartmentListData() {
    const filter = this.editForm.get('departmentFilter')?.value || '';
    let filteredList = this.departmentListData;
    if (this.showSelectedDepartmentOnly) {
      filteredList = filteredList.filter((item: { selected: any; }) => item.selected);
    }
    if (!filter.trim()) return filteredList;
    const filterValue = filter.trim().toLowerCase();
    return filteredList.filter((item: { item: { name: string; }; }) =>
      item.item.name.toLowerCase().includes(filterValue)
    );
  }

  get filteredMainGroupListData() {
    const filter = this.editForm.get('mainGroupFilter')?.value || '';
    let filteredList = this.mainGroupListData;
    if (this.showSelectedMainGroupOnly) {
      filteredList = filteredList.filter((item: { selected: any; }) => item.selected);
    }
    if (!filter.trim()) return filteredList;
    const filterValue = filter.trim().toLowerCase();
    return filteredList.filter((item: { item: { name: string; }; }) =>
      item.item.name.toLowerCase().includes(filterValue)
    );
  }

  get filteredGroupListData() {
    const filter = this.editForm.get('groupFilter')?.value || '';
    let filteredList = this.groupListData;
    if (this.showSelectedGroupOnly) {
      filteredList = filteredList.filter((item: { selected: any; }) => item.selected);
    }
    if (!filter.trim()) return filteredList;
    const filterValue = filter.trim().toLowerCase();
    return filteredList.filter((item: { item: { name: string; }; }) =>
      item.item.name.toLowerCase().includes(filterValue)
    );
  }

  get filteredItemListData() {
    const filter = this.editForm.get('itemFilter')?.value || '';
    let filteredList = this.itemListData;
    if (this.showSelectedItemOnly) {
      filteredList = filteredList.filter((item: { selected: any; }) => item.selected);
    }
    if (!filter.trim()) return filteredList;
    const filterValue = filter.trim().toLowerCase();
    return filteredList.filter((item: { item: { name: string; }; }) =>
      item.item.name.toLowerCase().includes(filterValue)
    );
  }

  get filteredOrderSourceListDataAll() {
    const filter = this.editForm.get('orderSourceFilterAll')?.value?.toLowerCase() || '';
    return this.orderSourceListData.filter((item: { selected: any; item: { name: string; }; }) =>
      !item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }
  get filteredOrderSourceListDataSelected() {
    const filter = this.editForm.get('orderSourceFilterSelected')?.value?.toLowerCase() || '';
    return this.orderSourceListData.filter((item: { selected: any; item: { name: string; }; }) =>
      item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }

  get filteredShopListDataAll() {
    const filter = this.editForm.get('shopFilterAll')?.value?.toLowerCase() || '';
    return this.shopListData.filter((item: { selected: any; item: { name: string; }; }) =>
      !item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }
  get filteredShopListDataSelected() {
    const filter = this.editForm.get('shopFilterSelected')?.value?.toLowerCase() || '';
    return this.shopListData.filter((item: { selected: any; item: { name: string; }; }) =>
      item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }

  get filteredAreaListDataAll() {
    const filter = this.editForm.get('regionFilterAll')?.value?.toLowerCase() || '';
    return this.areaListData.filter((item: { selected: any; item: { name: string; }; }) =>
      !item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }
  get filteredAreaListDataSelected() {
    const filter = this.editForm.get('regionFilterSelected')?.value?.toLowerCase() || '';
    return this.areaListData.filter((item: { selected: any; item: { name: string; }; }) =>
      item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }

  get filteredDepartmentListDataAll() {
    const filter = this.editForm.get('departmentFilterAll')?.value?.toLowerCase() || '';
    return this.departmentListData.filter((item: { selected: any; item: { name: string; }; }) =>
      !item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }
  get filteredDepartmentListDataSelected() {
    const filter = this.editForm.get('departmentFilterSelected')?.value?.toLowerCase() || '';
    return this.departmentListData.filter((item: { selected: any; item: { name: string; }; }) =>
      item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }

  get filteredMainGroupListDataAll() {
    const filter = this.editForm.get('mainGroupFilterAll')?.value?.toLowerCase() || '';
    return this.mainGroupListData.filter((item: { selected: any; item: { name: string; }; }) =>
      !item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }
  get filteredMainGroupListDataSelected() {
    const filter = this.editForm.get('mainGroupFilterSelected')?.value?.toLowerCase() || '';
    return this.mainGroupListData.filter((item: { selected: any; item: { name: string; }; }) =>
      item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }

  get filteredGroupListDataAll() {
    const filter = this.editForm.get('groupFilterAll')?.value?.toLowerCase() || '';
    return this.groupListData.filter((item: { selected: any; item: { name: string; }; }) =>
      !item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }
  get filteredGroupListDataSelected() {
    const filter = this.editForm.get('groupFilterSelected')?.value?.toLowerCase() || '';
    return this.groupListData.filter((item: { selected: any; item: { name: string; }; }) =>
      item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }

  get filteredItemListDataAll() {
    const filter = this.editForm.get('itemFilterAll')?.value?.toLowerCase() || '';
    return this.itemListData.filter((item: { selected: any; item: { name: string; }; }) =>
      !item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }
  get filteredItemListDataSelected() {
    const filter = this.editForm.get('itemFilterSelected')?.value?.toLowerCase() || '';
    return this.itemListData.filter((item: { selected: any; item: { name: string; }; }) =>
      item.selected && (!filter || item.item.name.toLowerCase().includes(filter))
    );
  }

  toggleContent(divData: string): void {
    if (divData == "expensetype") {
      this.isExpandedOrder = !this.isExpandedOrder;
    }
    if (divData == "areatype") {
      this.isExpandedArea = !this.isExpandedArea;
    }
    if (divData == "shoptype") {
      this.isExpandedShop = !this.isExpandedShop;
    }
    if (divData == "departmenttype") {
      this.isExpandedDepartment = !this.isExpandedDepartment;
    }
    if (divData == "maingrouptype") {
      this.isExpandedMainGroup = !this.isExpandedMainGroup;
    }
    if (divData == "grouptype") {
      this.isExpandedGroup = !this.isExpandedGroup;
    }
    if (divData == "itemtype") {
      this.isExpandedItem = !this.isExpandedItem;
    }
    if (divData == "itemtype") {
      this.isExpandedSort = !this.isExpandedSort;
    }
  }

  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach((el) => {
      if (el.selected) {
        count++;
      }
    });
    return sourceList.length + "/" + (count > 0 ? count : "ALL");
  }

  selectAll(list: any[], dropdownType: string) {
    list.forEach(item => item.selected = true);
    switch (dropdownType) {
      case 'order':
        this.isExpandedOrder = true;
        break;
      case 'shop':
        this.isExpandedShop = true;
        break;
      case 'area':
        this.isExpandedArea = true;
        break;
      case 'department':
        this.isExpandedDepartment = true;
        break;
      case 'mainGroup':
        this.isExpandedMainGroup = true;
        break;
      case 'group':
        this.isExpandedGroup = true;
        break;
      case 'item':
        this.isExpandedItem = true;
        break;
      // add more cases as needed
    }
  }
  resetDepartment(list: any[]) {
    list.forEach(item => item.selected = false);
    this.isExpandedDepartment = true;
  }
  selectAllDepartment(list: any[]) {
    list.forEach(item => item.selected = true);
    this.isExpandedDepartment = true;
  }
  reset(list: any[], dropdownType: string) {
    list.forEach(item => item.selected = false);
    switch (dropdownType) {
      case 'order':
        this.isExpandedOrder = true;
        break;
      case 'shop':
        this.isExpandedShop = true;
        break;
      case 'area':
        this.isExpandedArea = true;
        break;
      case 'department':
        this.isExpandedDepartment = true;
        break;
      case 'mainGroup':
        this.isExpandedMainGroup = true;
        break;
      case 'group':
        this.isExpandedGroup = true;
        break;
      case 'item':
        this.isExpandedItem = true;
        break;
      // add more cases as needed
    }
  }
  onShopSelectionChange(selectionData: any): void { }

  get selectedOrderSourcesCount(): number {
    return (
      this.orderSourceListData?.filter((item: any) => item.selected)?.length ||
      0
    );
  }
  get selectedShopSourcesCount(): number {
    return this.shopListData?.filter((item: any) => item.selected)?.length || 0;
  }
  get selectedAreaSourcesCount(): number {
    return this.areaListData?.filter((item: any) => item.selected)?.length || 0;
  }
  get selectedDepartmentSourcesCount() {
    return (
      this.departmentListData?.filter((item: any) => item.selected)?.length || 0
    );
  }
  get selectedMainGroupSourcesCount(): number {
    return (
      this.mainGroupListData?.filter((item: any) => item.selected)?.length || 0
    );
  }
  get selectedGroupSourcesCount(): number {
    return (
      this.groupListData?.filter((item: any) => item.selected)?.length || 0
    );
  }

  getSelectAllIconOrder(): string {
    if (!this.orderSourceListData || this.orderSourceListData.length === 0) return 'check_box_outline_blank';
    if (this.selectedOrderSourcesCount === this.orderSourceListData.length) {
      return 'check_box';
    } else if (this.selectedOrderSourcesCount > 0) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  toggleSelectAllOrder() {
    if (this.selectedOrderSourcesCount === this.orderSourceListData.length) {
      this.reset(this.orderSourceListData, 'order');
    } else {
      this.selectAll(this.orderSourceListData, 'order');
    }
  }

  getSelectAllIconShop(): string {
    if (!this.shopListData || this.shopListData.length === 0) return 'check_box_outline_blank';
    if (this.selectedShopSourcesCount === this.shopListData.length) {
      return 'check_box';
    } else if (this.selectedShopSourcesCount > 0) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  toggleSelectAllShop() {
    if (this.selectedShopSourcesCount === this.shopListData.length) {
      this.reset(this.shopListData, 'shop');
    } else {
      this.selectAll(this.shopListData, 'shop');
    }
  }

  getSelectAllIconRegion(): string {
    if (!this.areaListData || this.areaListData.length === 0) return 'check_box_outline_blank';
    if (this.selectedAreaSourcesCount === this.areaListData.length) {
      return 'check_box';
    } else if (this.selectedAreaSourcesCount > 0) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  toggleSelectAllRegion() {
    if (this.selectedAreaSourcesCount === this.areaListData.length) {
      this.reset(this.areaListData, 'area');
    } else {
      this.selectAll(this.areaListData, 'area');
    }
  }

  getSelectAllIconDepartment(): string {
    if (!this.departmentListData || this.departmentListData.length === 0) return 'check_box_outline_blank';
    if (this.selectedDepartmentSourcesCount === this.departmentListData.length) {
      return 'check_box';
    } else if (this.selectedDepartmentSourcesCount > 0) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  toggleSelectAllDepartment() {
    if (this.selectedDepartmentSourcesCount === this.departmentListData.length) {
      this.reset(this.departmentListData, 'department');
    } else {
      this.selectAll(this.departmentListData, 'department');
    }
  }

  getSelectAllIconMainGroup(): string {
    if (!this.mainGroupListData || this.mainGroupListData.length === 0) return 'check_box_outline_blank';
    if (this.selectedMainGroupSourcesCount === this.mainGroupListData.length) {
      return 'check_box';
    } else if (this.selectedMainGroupSourcesCount > 0) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  toggleSelectAllMainGroup() {
    if (this.selectedMainGroupSourcesCount === this.mainGroupListData.length) {
      this.reset(this.mainGroupListData, 'mainGroup');
    } else {
      this.selectAll(this.mainGroupListData, 'mainGroup');
    }
  }

  getSelectAllIconGroup(): string {
    if (!this.groupListData || this.groupListData.length === 0) return 'check_box_outline_blank';
    if (this.selectedGroupSourcesCount === this.groupListData.length) {
      return 'check_box';
    } else if (this.selectedGroupSourcesCount > 0) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  toggleSelectAllGroup() {
    if (this.selectedGroupSourcesCount === this.groupListData.length) {
      this.reset(this.groupListData, 'group');
    } else {
      this.selectAll(this.groupListData, 'group');
    }
  }

  getSelectAllIconItem(): string {
    if (!this.itemListData || this.itemListData.length === 0) return 'check_box_outline_blank';
    if (this.selectedItemSourcesCount === this.itemListData.length) {
      return 'check_box';
    } else if (this.selectedItemSourcesCount > 0) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  toggleSelectAllItem() {
    if (this.selectedItemSourcesCount === this.itemListData.length) {
      this.reset(this.itemListData, 'item');
    } else {
      this.selectAll(this.itemListData, 'item');
    }
  }
  get selectedItemSourcesCount(): number {
    return this.itemListData?.filter((item: any) => item.selected)?.length || 0;
  }

  navigateToWeeklyReport() {
    this.router.navigate(["/weekly-result-store-report-view"]);
    // or with parameters if needed:
    // this.router.navigate(['/weekly-result-store-report-view', {param: value}]);
  }

  exportClicked(): void {
    if (this.editForm.valid) {
      this.IsDownloading = true;

      // Get selected shop IDs (if none are selected, treat it as "ALL")
      const selectedShopIds = this.shopListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selectedDepartmentIds = this.departmentListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      
      // ============================================================
      // ORDER SOURCE MAPPING:
      // Uses the 'key' property from API response:
      // - Instore       → key: 0
      // - Online Store  → key: 12
      // - Third Party   → key: 21
      // ============================================================
      const selectedOrerSourcesIds = this.orderSourceListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.key);
      
      const selectedAreaIds = this.areaListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selectedCashierIds = this.usersListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selectedMainGroupIds = this.mainGroupListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selectedGroupIds = this.groupListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);
      const selecteditemIds = this.itemListData
        .filter((shop: any) => shop.selected)
        .map((shop: any) => shop.item.id);

      const departmentIds =
        selectedDepartmentIds.length > 0 ? selectedDepartmentIds : [];
      const orderIds =
        selectedOrerSourcesIds.length > 0 ? selectedOrerSourcesIds : [];
      const areaIds = selectedAreaIds.length > 0 ? selectedAreaIds : [];
      const casherlIds = selectedCashierIds.length > 0 ? selectedCashierIds : [];
      const mainGroupIds =
        selectedMainGroupIds.length > 0 ? selectedMainGroupIds : [];
      const GroupIds = selectedGroupIds.length > 0 ? selectedGroupIds : [];
      const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

      var rawDateFrom = this.editForm.get("period_from")?.value;
      var formattedDateFrom = moment(rawDateFrom).format("YYYY-MM-DD");
      var rawDateTo = this.editForm.get("period_to")?.value;
      var formattedDateTo = moment(rawDateTo).format("YYYY-MM-DD");
      var days = this.selectedDays();
      // Create the data object
      if (this.user?.shop_info !== null && this.user?.shop_info !== undefined) {
        this.shop_id = this.user?.shop_info.id;
        this.shop_name = this.user?.shop_info.name;
      }
      const reportData = {
        dateFrom: formattedDateFrom,
        dateTo: formattedDateTo,
        orderSource: orderIds,
        shopFrom: shopIds,
        regionFrom: areaIds,
        deptFrom: departmentIds,
        mainGroupFrom: mainGroupIds,
        groupFrom: GroupIds,
        itemFrom: selecteditemIds,
        sortBy: this.editForm.get("sortBy")?.value,
        orderBy: this.editForm.get("orderBy")?.value,
        includeShopDetails: this.editForm.get("includeShopDetails")?.value
          ? 1
          : 0,
        shopName: this.shop_name,
        showDepGrpMainGrp: this.editForm.get("showDepGrpMainGrp")?.value ? 1 : 0 // <-- add this line

      };
      if (reportData) {
        this.masterSalesReportService
          .exportMasterSalesReport(reportData)
          .subscribe({
            next: (response: Blob) => {
              this.handleExportResponse(response, 'master-sales-report.xlsx');
            },
            error: (error) => {
              console.error("Error fetching data:", error);
              this.handleExportError();
            },
          });
      } else {
        this.handleValidationError();
      }
    } else {
      // Check for date range error
      if (this.editForm.errors && this.editForm.errors['dateRangeTooLong']) {
        let snackBarData: SnackBarData = {
          message: 'Please choose a date range shorter than 365 days.',
          title: 'Invalid Date Range',
          type: 'warn'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.editForm.markAllAsTouched();
    }
  }

  shopList(): void {
    let requestData = {
      search: {
        filters: { filter: [], scope: { offset: 0, limit: 1000000 } },
        sort: [{ column: "shop.name", order: "ASC" }],
      },
    };

    this.ShopinfoService.getShopList(requestData).subscribe(
      (response: any) => {
        this.shopListData = [];
        var index = 0;
        response.data.shops.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.shopListData.push(data);
          index++;
        });
      },
      (error: any) => { }
    );
  }

  // Helper methods
  private handleExportResponse(response: Blob, filename: string): void {
    const reader = new FileReader();

    reader.onload = () => {
      try {
        const text = reader.result as string;
        const json = JSON.parse(text);

        switch (json.status) {
          case 'NO_DATA_FOUND':
            this.showMessage('No data found.', 'No Data Found!', 'warn');
            break;
          case 'ERROR':
          case 'FAILED':
            this.showMessage(json.message || 'An error occurred while generating the report.', 'Error!', 'error');
            break;
          default:
            this.showMessage('Unexpected response from server.', 'Warning!', 'warn');
        }
        this.IsDownloading = false;

      } catch (e) {
        this.downloadFile(response, filename);
      }
    };

    reader.readAsText(response);
  }

  private downloadFile(response: Blob, filename: string): void {
    if (response.size === 0 || response.size < 100) {
      this.showMessage('No data available for export.', 'No Data Found!', 'warn');
      this.IsDownloading = false;
      return;
    }

    const blob = new Blob([response], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.IsDownloading = false;

    this.showMessage('Report downloaded successfully.', 'Success!', 'success');
  }

  private handleExportError(): void {
    this.IsDownloading = false;
    this.showMessage('An error occurred while fetching the report. Please try again.', 'Error!', 'error');
  }

  private handleValidationError(): void {
    this.editForm.markAllAsTouched();
    this.showMessage('Please fill all required fields.', 'Validation Error', 'error');
  }

  private showMessage(message: string, title: string, type: 'success' | 'error' | 'warn'): void {
    let snackBarData: SnackBarData = {
      message: message,
      title: title,
      type: type
    }
    this.snackBarService.openSnackBar(snackBarData);
  }
}
